/**
 * ResponsavelConfigWhatsappCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponsavelConfigWhatsapp} from '@/model/resource/ResponsavelConfigWhatsapp'

/* TODO: review generated class */
@HttpExclude()
export class ResponsavelConfigWhatsappCollection extends PageCollection<
  ResponsavelConfigWhatsapp
> {
  constructor() {
    super(ResponsavelConfigWhatsapp)
  }

  queryAsPage() {
    return this.listResponsavelConfigWhatsapp()
  }

  async listResponsavelConfigWhatsapp() {
    return await Request.get(`/admin/responsvel-config-whatsapp`, {
      params: this.params,
    })
      .name('listResponsavelConfigWhatsapp')
      .as(this)
      .getResponse()
  }

  async listCsvResponsavelConfigWhatsapp() {
    return await Request.get(`/admin/responsvel-config-whatsapp/csv`, {
      params: this.params,
    })
      .name('listCsvResponsavelConfigWhatsapp')
      .as(this)
      .getResponse()
  }
}
